import { useEffect, useState, type FC } from "react";
import { formatDate } from "../lib/date_utils";

function formatTimeAgo(iso: string, nowMs: number): string {
  const deltaMs = nowMs - new Date(iso).getTime();

  if (!Number.isFinite(deltaMs)) {
    return "-";
  }

  const seconds = Math.max(0, Math.floor(deltaMs / 1000));

  if (seconds < 60) {
    return "just now";
  }

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    return `${minutes}m ago`;
  }

  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `${hours}h ago`;
  }

  const days = Math.floor(hours / 24);
  if (days < 30) {
    return `${days}d ago`;
  }

  const months = Math.floor(days / 30);
  if (months < 12) {
    return `${months}mo ago`;
  }

  const years = Math.floor(days / 365);
  return `${years}y ago`;
}

export const TimeAgo: FC<{
  iso?: string;
}> = ({ iso }) => {
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    if (iso === undefined) {
      return;
    }

    const id = window.setInterval(() => {
      setNowMs(Date.now());
    }, 60_000);

    return () => window.clearInterval(id);
  }, [iso]);

  if (iso === undefined) {
    return <span>-</span>;
  }

  return <span title={formatDate(iso)}>{formatTimeAgo(iso, nowMs)}</span>;
};
